export default "__VITE_ASSET__DzO0YPIm__"